import React, { useState } from 'react';

import Button from './Button';

const QuickActionsToolbar = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const quickActions = [
    {
      id: 'emergency-stop',
      label: 'Emergency Stop',
      icon: 'AlertOctagon',
      variant: 'destructive',
      shortcut: 'Alt+E',
      critical: true,
      onClick: () => handleEmergencyStop()
    },
    {
      id: 'acknowledge-alert',
      label: 'Acknowledge Alert',
      icon: 'CheckCircle2',
      variant: 'warning',
      shortcut: 'Alt+A',
      onClick: () => handleAcknowledgeAlert()
    },
    {
      id: 'status-update',
      label: 'Status Update',
      icon: 'RefreshCw',
      variant: 'outline',
      shortcut: 'Alt+S',
      onClick: () => handleStatusUpdate()
    },
    {
      id: 'quality-flag',
      label: 'Quality Flag',
      icon: 'Flag',
      variant: 'outline',
      shortcut: 'Alt+Q',
      onClick: () => handleQualityFlag()
    }
  ];

  const handleEmergencyStop = () => {
    console.log('Emergency stop initiated');
  };

  const handleAcknowledgeAlert = () => {
    console.log('Alert acknowledged');
  };

  const handleStatusUpdate = () => {
    console.log('Status update requested');
  };

  const handleQualityFlag = () => {
    console.log('Quality flag raised');
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col items-end gap-2">
      <div className={`flex flex-col gap-2 transition-all duration-250 ${isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {quickActions?.map((action) => (
          <div
            key={action?.id}
            className="flex items-center gap-3 bg-card rounded-xl shadow-lg border border-border p-2"
          >
            <Button
              variant={action?.variant}
              size="lg"
              iconName={action?.icon}
              onClick={action?.onClick}
              className="min-w-[48px]"
            >
              <span className="hidden sm:inline ml-2">{action?.label}</span>
            </Button>
            <span className="caption text-muted-foreground hidden md:inline pr-2">
              {action?.shortcut}
            </span>
          </div>
        ))}
      </div>
      <Button
        variant="primary"
        size="lg"
        iconName={isExpanded ? 'X' : 'Zap'}
        onClick={toggleExpanded}
        className="shadow-lg"
      >
        <span className="hidden sm:inline ml-2">Quick Actions</span>
      </Button>
    </div>
  );
};

export default QuickActionsToolbar;